import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

const DeleteItem = ({ title, visible, onHide, deleteItem }: any) => {

  const footer = (
    <div className='flex justify-content-center	gap-3'>
      <Button label="No" icon="pi pi-times" onClick={onHide} severity="danger" className="m-0" outlined />
      <Button label="Yes" icon="pi pi-check" onClick={deleteItem} className="primary m-0" />
    </div>
  );

  return (
    <Dialog header={`Confirm Delete ${title}`} visible={visible} footer={footer} onHide={onHide}>
      <p>Do you really want to delete this {title}?</p>
    </Dialog>
  );
};

export default DeleteItem;
